import { render, staticRenderFns } from "./createArticleNew.vue?vue&type=template&id=7fc42b01&scoped=true&"
import script from "./createArticleNew.vue?vue&type=script&lang=js&"
export * from "./createArticleNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc42b01",
  null
  
)

export default component.exports